import { useState, useEffect, useRef } from "react";
import {
  FaCog,
  FaVolumeUp,
  FaBullhorn,
  FaMusic,
  FaCheck,
  FaGamepad,
} from "react-icons/fa";
import "./Bingo.css";
import { toast, ToastContainer } from "react-toastify";
import { updateDoc } from "firebase/firestore";
import { updateDocument } from "../../firebase-functions/database";
import { auth } from "../../firebase-functions/config";
// Main application component
export const Bingo = ({ readerProfile }) => {
  // A single state object to hold all game state.
  const [gameState, setGameState] = useState(() => {
    // We will no longer load a saved game from local storage,
    // so we can always return a clean initial state.
    return {
      view: "home",

      calledNumbers: [],
      lastCalledNumber: null,
      playerBoards: [],
      isGameStarted: false,
      uncalledNumbersDeck: [],
      gameOver: false,
      gameWon: false,
    };
  });

  const bingoAudioRef = useRef(null);
  const bgMusicRef = useRef(null);
  const countdownAudioRef = useRef(null);
  const crowdAudioRef = useRef(null);
  const winAudioRef = useRef(null);
  const bingoAnnounceRef = useRef(null);

  const [message, setMessage] = useState("");
  const [isPunished, setIsPunished] = useState(false);
  const [showPlayButton, setShowPlayButton] = useState(false);
  // Music controls
  const [musicEnabled, setMusicEnabled] = useState(true);
  const [musicVolume, setMusicVolume] = useState(0.4);
  const [bingoCallVolume, setBingoCallVolume] = useState(0.5);
  const [showSettings, setShowSettings] = useState(false);
  const [rememberSettings, setRememberSettings] = useState(true);
  const [bingoEnabled, setBingoEnabled] = useState(true);
  const [isPaused, setIsPaused] = useState(false);

  const [countdownStep, setCountdownStep] = useState(null);

  const startCountdown = () => {
    setTimeout(() => setCountdownStep(3), 2000);
    setTimeout(() => setCountdownStep(2), 3000);
    setTimeout(() => setCountdownStep(1), 4000);
    setTimeout(() => setCountdownStep("GO"), 5000);
    setTimeout(() => setCountdownStep(null), 6000);
  };

  // Deconstruct the game state for easier access
  const {
    view,

    calledNumbers,
    lastCalledNumber,
    playerBoards,
    isGameStarted,
    uncalledNumbersDeck,
    gameOver,
    gameWon,
  } = gameState;

  const BINGO_LETTERS = ["B", "I", "N", "G", "O"];
  const BINGO_RANGES = {
    B: [1, 15],
    I: [16, 30],
    N: [31, 45],
    G: [46, 60],
    O: [61, 75],
  };
  const allNumbers = Array.from({ length: 75 }, (_, i) => i + 1);

  useEffect(() => {
    bingoAudioRef.current = new Audio(
      "https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fbingo%2Fall_calls_stitched.mp3?alt=media&token=962207f8-0727-4d8e-a0c4-1f50bf4c5e58"
    );
    // Optional: Preload the audio
    bingoAudioRef.current.preload = "auto";
    bingoAudioRef.current.volume = bingoCallVolume;
  }, []);

  // Load background music only once
  useEffect(() => {
    bgMusicRef.current = new Audio(
      "https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fbingo%2FUno%20Mobile%20music%20ost%20-%20BGM%202.mp3?alt=media&token=31e29f1e-e832-42d7-a472-0bd6e7ef1a81"
    );
    bgMusicRef.current.loop = true;
    bgMusicRef.current.preload = "auto";
    bgMusicRef.current.volume = musicVolume;
  }, []);

  useEffect(() => {
    countdownAudioRef.current = new Audio(
      "https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fbingo%2F321.mp3?alt=media&token=e40a8915-533c-4d06-9e9d-77660fc63c0e"
    );
    countdownAudioRef.current.preload = "auto";
  }, []);

  useEffect(() => {
    crowdAudioRef.current = new Audio(
      "https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fbingo%2Fcrowd-disappointment-reaction-352718.mp3?alt=media&token=b4e67eb8-25e4-46aa-8040-b20dc0094262"
    );
    crowdAudioRef.current.preload = "auto";
  }, []);

  useEffect(() => {
    winAudioRef.current = new Audio(
      "https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fbingo%2Fcrowd-cheer-and-applause-406644.mp3?alt=media&token=de0e39be-9dba-4350-a46b-7eb451193251"
    );
    winAudioRef.current.preload = "auto";
  }, []);

  useEffect(() => {
    bingoAnnounceRef.current = new Audio(
      "https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fbingo%2Fbingo-announce.mp3?alt=media&token=623b276e-c80b-432d-80e1-633410015f86"
    );
    bingoAnnounceRef.current.preload = "auto";
  }, []);

  useEffect(() => {
    if (gameOver && !gameWon && crowdAudioRef.current) {
      crowdAudioRef.current.currentTime = 0;
      crowdAudioRef.current.play();
    }
  }, [gameOver, gameWon]);

  // Update volume when changed
  useEffect(() => {
    if (bgMusicRef.current) {
      bgMusicRef.current.volume = musicVolume;
    }
  }, [musicVolume]);

  useEffect(() => {
    if (bgMusicRef.current) {
      if (isGameStarted && musicEnabled) {
        bgMusicRef.current.play();
      } else {
        bgMusicRef.current.pause();
        bgMusicRef.current.currentTime = 0;
      }
    }
  }, [isGameStarted, musicEnabled, gameOver, gameWon]);

  useEffect(() => {
    if (bingoAudioRef.current) {
      bingoAudioRef.current.volume = bingoCallVolume;
    }
  }, [bingoCallVolume]);
  useEffect(() => {
    if (bingoAudioRef.current) {
      bingoAudioRef.current.muted = !bingoEnabled;
    }
  }, [bingoEnabled]);

  useEffect(() => {
    if (gameWon) {
      if (winAudioRef.current) {
        winAudioRef.current.currentTime = 0;
        winAudioRef.current.play();
      }
      if (bingoAnnounceRef.current) {
        bingoAnnounceRef.current.currentTime = 0;
        setTimeout(() => {
          bingoAnnounceRef.current.play();
        }, 500); // Delay to avoid overlap with win sound
      }
    }
  }, [gameWon]);

  // Helper function to calculate the cost based on the number of boards.
  const getBoardCost = (count) => {
    if (count === 1) return 100;
    if (count === 2) return 150;
    if (count === 3) return 175;
    if (count === 4) return 200;
    return 0;
  };

  const handlePauseResume = () => {
    setIsPaused((prev) => !prev);
    // Add your pause/resume logic here
  };

  const handleQuitGame = () => {
    localStorage.removeItem("bingoGame");
    setShowSettings(false);
    setGameState({
      view: "home",

      calledNumbers: [],
      lastCalledNumber: null,
      playerBoards: [],
      isGameStarted: false,
      uncalledNumbersDeck: [],
      gameOver: false,
      gameWon: false,
    });
    setIsPaused(false);
    setMessage("Game quit. Returning to main menu.");
  };

  // Helper function to play a sound
  const playSound = () => {
    const audioContext = new (window.AudioContext ||
      window.webkitAudioContext)();
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();

    // Connect oscillator to gain node, and gain node to destination (speakers)
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);

    // Set oscillator parameters
    oscillator.type = "sine"; // Can be 'sine', 'square', 'sawtooth', 'triangle'
    oscillator.frequency.setValueAtTime(440, audioContext.currentTime); // Frequency in Hz (A4)

    // Set gain parameters
    gainNode.gain.setValueAtTime(0.5, audioContext.currentTime); // Volume
    gainNode.gain.exponentialRampToValueAtTime(
      0.001,
      audioContext.currentTime + 0.5
    ); // Fade out

    // Start and stop the oscillator
    oscillator.start();
    oscillator.stop(audioContext.currentTime + 0.5);
  };

  const playBingoCall = (callNumber, cutOutTime) => {
    const audio = bingoAudioRef.current;

    if (!audio) return;
    audio.pause();

    audio.currentTime = (callNumber - 1) * 8;
    audio.play();

    // Stop after 8 seconds to avoid overlap
    setTimeout(() => {
      audio.pause();
      audio.currentTime = 0;
    }, cutOutTime - 200 || 8000);
  };

  // Effect to load game state from localStorage on component mount
  useEffect(() => {
    try {
      const savedGame = localStorage.getItem("bingoGame");
      if (savedGame) {
        const parsedGame = JSON.parse(savedGame);
        // This is the key change: we load the state but force isGameStarted to be false.
        setGameState({ ...parsedGame, isGameStarted: false });
        setShowPlayButton(true);
        setMessage("Saved game loaded! Press Continue Game to resume.");
      }
    } catch (error) {
      console.error("Failed to load state from localStorage:", error);
      // Optionally, clear invalid storage to prevent future errors
      localStorage.removeItem("bingoGame");
    }
  }, []); // Empty dependency array ensures this runs only once on mount

  // Effect to save game state to localStorage whenever the state object changes
  // This is now the ONLY place where local storage is written.
  useEffect(() => {
    try {
      if (isGameStarted) {
        localStorage.setItem("bingoGame", JSON.stringify(gameState));
      }
    } catch (error) {
      console.error("Failed to save state to localStorage:", error);
    }
  }, [gameState, isGameStarted]);

  // Effect to manage the game loop and timer
  useEffect(() => {
    let timeoutId;

    // Check for game over conditions first
    if (calledNumbers.length >= 50 && !gameOver) {
      timeoutId = setTimeout(() => {
        setGameState((prev) => ({
          ...prev,
          gameOver: true,
          isGameStarted: false,
        }));
        setMessage("Game over! The game has ended after 50 calls.");
      }, 5000);
      return () => {
        if (timeoutId) clearTimeout(timeoutId);
      };
    }

    // Only proceed if the game is started and not over
    if (isGameStarted && !gameOver && !gameWon && !isPaused) {
      const initialInterval = 7000;
      const finalInterval = 4500;
      const totalCallsForDecrease = 50;
      const currentCallCount = calledNumbers.length;

      let calculatedInterval = initialInterval;
      if (currentCallCount === 0) {
        calculatedInterval = 6000; // First call is instant
        startCountdown();
        // Pause bg music before countdown
        if (bgMusicRef.current) {
          bgMusicRef.current.pause();
          bgMusicRef.current.currentTime = 0;
          setTimeout(() => {
            bgMusicRef.current.play();
          }, 5000); // Resume after countdown
        }

        if (countdownAudioRef.current) {
          countdownAudioRef.current.currentTime = 0;
          countdownAudioRef.current.play();
        }
      } else if (currentCallCount < totalCallsForDecrease) {
        const decreaseAmount = initialInterval - finalInterval;
        const decreasePerCall = decreaseAmount / (totalCallsForDecrease - 1);
        calculatedInterval =
          initialInterval - currentCallCount * decreasePerCall;
      } else {
        calculatedInterval = finalInterval;
      }

      timeoutId = setTimeout(() => {
        playSound();
        playBingoCall(
          uncalledNumbersDeck[calledNumbers.length] || 1,
          calculatedInterval
        );
        setGameState((prev) => {
          const nextNumber =
            prev.uncalledNumbersDeck[prev.calledNumbers.length];
          return {
            ...prev,
            lastCalledNumber: nextNumber,
            calledNumbers: [...prev.calledNumbers, nextNumber],
          };
        });
      }, calculatedInterval);
    }

    // Cleanup function for the timeout
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isGameStarted, gameOver, gameWon, calledNumbers, isPaused]);

  const handlePlaySavedGame = () => {
    setShowPlayButton(false);
    setIsPaused(false);
    setGameState((prev) => ({
      ...prev,
      isGameStarted: true,
    }));
    setMessage("");
  };

  // Helper function to get the Bingo letter for a number
  const getBingoLetter = (num) => {
    if (num >= 1 && num <= 15) return "B";
    if (num >= 16 && num <= 30) return "I";
    if (num >= 31 && num <= 45) return "N";
    if (num >= 46 && num <= 60) return "G";
    if (num >= 61 && num <= 75) return "O";
    return "";
  };

  // Check for a winning condition (Bingo!)
  const checkForBingo = (boards) => {
    const rows = 5;
    const cols = 5;

    for (const board of boards) {
      // Check rows and columns
      for (let i = 0; i < rows; i++) {
        let rowBingo = true;
        let colBingo = true;
        for (let j = 0; j < cols; j++) {
          if (!board[BINGO_LETTERS[j]][i].marked) rowBingo = false;
          if (!board[BINGO_LETTERS[i]][j].marked) colBingo = false;
        }
        if (rowBingo || colBingo) {
          setGameState((prev) => ({
            ...prev,
            gameOver: true,
            gameWon: true,
            isGameStarted: false,
          }));
          return true;
        }
      }

      // Check diagonals
      let diag1Bingo = true;
      let diag2Bingo = true;
      for (let i = 0; i < rows; i++) {
        if (!board[BINGO_LETTERS[i]][i].marked) diag1Bingo = false;
        if (!board[BINGO_LETTERS[i]][rows - 1 - i].marked) diag2Bingo = false;
      }
      if (diag1Bingo || diag2Bingo) {
        setGameState((prev) => ({
          ...prev,
          gameOver: true,
          gameWon: true,
          isGameStarted: false,
        }));
        return true;
      }
    }
    return false;
  };

  // Handle a square being marked by the user
  const handleMarkSquare = (boardIndex, row, col) => {
    if (gameOver || gameWon || !isGameStarted) return;
    const letter = BINGO_LETTERS[col];
    const cell = playerBoards[boardIndex][letter][row];
    if (cell.marked) return;

    if (calledNumbers.includes(cell.value)) {
      const newBoards = [...playerBoards];
      newBoards[boardIndex] = { ...newBoards[boardIndex] };
      newBoards[boardIndex][letter][row] = { ...cell, marked: true };
      setGameState((prev) => ({
        ...prev,
        playerBoards: newBoards,
      }));
    } else {
      // Punish the user for an incorrect click
      setIsPunished(true);
      setTimeout(() => setIsPunished(false), 500);

      setMessage("That number has not been called yet!");
      setTimeout(() => setMessage(""), 3000);
    }
  };

  // Handler for the new "Bingo!" button
  const handleCallBingo = () => {
    if (gameWon) return; // Prevent multiple calls
    const hasBingo = checkForBingo(playerBoards);
    if (!hasBingo) {
      setMessage("Oops, that's not a Bingo!");
      // The message will be cleared by the next automatic message,
      // but we can also set a timeout to clear it manually.
      setTimeout(() => setMessage(""), 3000);
    }
  };

  // Fisher-Yates Shuffle algorithm for a reliable shuffle
  const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };

  const generateBingoCard = () => {
    const card = {};
    BINGO_LETTERS.forEach((letter) => {
      const [min, max] = BINGO_RANGES[letter];
      const numbers = new Set();
      while (numbers.size < 5) {
        numbers.add(Math.floor(Math.random() * (max - min + 1)) + min);
      }
      card[letter] = Array.from(numbers)
        .sort((a, b) => a - b)
        .map((num) => ({ value: num, marked: false }));
    });
    card["N"][2] = { value: "FREE", marked: true };
    return card;
  };

  // Pre-made board data
  const PREMADE_BOARDS = [
    {
      id: "board1",
      title: "Beginner Board",
      description: "Easy to get started with.",
      board: {
        B: [
          { value: 2, marked: false },
          { value: 7, marked: false },
          { value: 9, marked: false },
          { value: 11, marked: false },
          { value: 15, marked: false },
        ],
        I: [
          { value: 16, marked: false },
          { value: 19, marked: false },
          { value: 24, marked: false },
          { value: 27, marked: false },
          { value: 30, marked: false },
        ],
        N: [
          { value: 32, marked: false },
          { value: 35, marked: false },
          { value: "FREE", marked: true },
          { value: 41, marked: false },
          { value: 44, marked: false },
        ],
        G: [
          { value: 46, marked: false },
          { value: 50, marked: false },
          { value: 53, marked: false },
          { value: 58, marked: false },
          { value: 60, marked: false },
        ],
        O: [
          { value: 61, marked: false },
          { value: 64, marked: false },
          { value: 69, marked: false },
          { value: 72, marked: false },
          { value: 75, marked: false },
        ],
      },
    },
    {
      id: "board2",
      title: "Diagonal Board",
      description: "Try for a diagonal win!",
      board: {
        B: [
          { value: 1, marked: false },
          { value: 3, marked: false },
          { value: 6, marked: false },
          { value: 10, marked: false },
          { value: 14, marked: false },
        ],
        I: [
          { value: 18, marked: false },
          { value: 20, marked: false },
          { value: 22, marked: false },
          { value: 25, marked: false },
          { value: 28, marked: false },
        ],
        N: [
          { value: 31, marked: false },
          { value: 33, marked: false },
          { value: "FREE", marked: true },
          { value: 38, marked: false },
          { value: 42, marked: false },
        ],
        G: [
          { value: 47, marked: false },
          { value: 51, marked: false },
          { value: 55, marked: false },
          { value: 59, marked: false },
          { value: 60, marked: false },
        ],
        O: [
          { value: 62, marked: false },
          { value: 66, marked: false },
          { value: 68, marked: false },
          { value: 70, marked: false },
          { value: 73, marked: false },
        ],
      },
    },
  ];

  const handleStartGame = (boardsToPlay, cost) => {
    if (!readerProfile) {
      toast.error("Reader profile is required to play!", {
        position: "top-center",
      });
      return;
    }
    let temp1 = readerProfile.stars || 0;
    let temp2 = readerProfile.starDeduction || 0;
    const currency = temp1 - temp2;

    if (currency < cost) {
      // setMessage("Not enough currency to play!");
      toast.error("Not enough gold to play!", { position: "top-center" });
      return;
    }
    updateDocument(
      "demoReaders",
      readerProfile.id,
      {
        starDeduction: (readerProfile.starDeduction || 0) + cost,
      },
      auth.currentUser
    ).then((res) => {
      if (!res.success) {
        toast.error(res.message);
        return;
      }
    });

    const shuffledDeck = shuffleArray([...allNumbers]);

    setGameState((prev) => ({
      ...prev,
      playerBoards: boardsToPlay,
      calledNumbers: [],
      lastCalledNumber: null,
      gameOver: false,
      gameWon: false,
      isGameStarted: true,
      view: "game",
      uncalledNumbersDeck: shuffledDeck,
    }));
    setMessage("");
  };

  // ...below your other components in Bingo.jsx...

  const SettingsOverlay = ({
    onClose,
    musicEnabled,
    setMusicEnabled,
    musicVolume,
    setMusicVolume,
    bingoCallVolume,
    setBingoCallVolume,
    bingoEnabled,
    setBingoEnabled,
    rememberSettings,
    setRememberSettings,
    onSave,
    onPauseResume,
    onQuit,
    isPaused,
  }) => {
    // Close overlay when clicking outside the box
    const overlayRef = useRef();

    useEffect(() => {
      const handleClickOutside = (e) => {
        if (overlayRef.current && !overlayRef.current.contains(e.target)) {
          onClose();
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }, [onClose]);

    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.6)",
          zIndex: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          ref={overlayRef}
          style={{
            background: "#fff",
            borderRadius: "1rem",
            padding: "2rem",
            minWidth: "340px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
            display: "flex",
            flexDirection: "column",
            gap: "1.5rem",
          }}
        >
          <div
            style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}
          >
            <FaCog style={{ fontSize: "1.5rem" }} />
            <h2 style={{ margin: 0, fontWeight: 800, fontSize: "1.25rem" }}>
              Settings
            </h2>
          </div>

          <div className="settings-overlay-subheader">
            <FaGamepad style={{ fontSize: "1.2rem" }} />
            <span>Game</span>
          </div>
          <div className="settings-section">
            <div className="settings-section-row" style={{ gap: "1rem" }}>
              <button
                className="settings-save-btn"
                style={{ background: "#f59e42" }}
                onClick={onPauseResume}
              >
                {isPaused ? "Resume Game" : "Pause Game"}
              </button>
              <button
                className="settings-save-btn"
                style={{ background: "#ef4444" }}
                onClick={onQuit}
              >
                Quit Game
              </button>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <FaVolumeUp style={{ fontSize: "1.2rem" }} />
            <span style={{ fontWeight: 700, fontSize: "1rem" }}>Sound</span>
          </div>
          {/* Announcer Sound */}
          <div>
            <div
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <FaBullhorn style={{ fontSize: "1.1rem" }} />
              <span style={{ fontWeight: 600 }}>Announcer Sound</span>
              <label style={{ marginLeft: "auto", fontWeight: 500 }}>
                <input
                  type="checkbox"
                  checked={bingoEnabled}
                  onChange={() => setBingoEnabled((v) => !v)}
                  style={{ marginRight: "0.5em" }}
                />
                {bingoEnabled ? "Enabled" : "Disabled"}
              </label>
            </div>
            <div style={{ marginTop: "0.5rem" }}>
              <input
                type="range"
                min={0}
                max={1}
                step={0.01}
                value={bingoCallVolume}
                onChange={(e) => setBingoCallVolume(Number(e.target.value))}
                disabled={!bingoEnabled}
                style={{ width: "100%" }}
              />
            </div>
          </div>
          {/* Background Music */}
          <div>
            <div
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <FaMusic style={{ fontSize: "1.1rem" }} />
              <span style={{ fontWeight: 600 }}>Background Music</span>
              <label style={{ marginLeft: "auto", fontWeight: 500 }}>
                <input
                  type="checkbox"
                  checked={musicEnabled}
                  onChange={() => setMusicEnabled((v) => !v)}
                  style={{ marginRight: "0.5em" }}
                />
                {musicEnabled ? "Enabled" : "Disabled"}
              </label>
            </div>
            <div style={{ marginTop: "0.5rem" }}>
              <input
                type="range"
                min={0}
                max={1}
                step={0.01}
                value={musicVolume}
                onChange={(e) => setMusicVolume(Number(e.target.value))}
                disabled={!musicEnabled}
                style={{ width: "100%" }}
              />
            </div>
          </div>
          {/* Remember and Save */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "1rem",
            }}
          >
            <label
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <input
                type="checkbox"
                checked={rememberSettings}
                onChange={() => setRememberSettings((v) => !v)}
                style={{
                  margin: "0 0.5rem 0 0",
                  height: "1.25em",
                  width: "1.25em",
                }}
              />
              Remember
            </label>
            <button
              onClick={onSave}
              style={{
                background: "#3b82f6",
                color: "#fff",
                border: "none",
                borderRadius: "0.5rem",
                padding: "0.5rem 1.25rem",
                fontWeight: 700,
                fontSize: "1rem",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                width: "fit-content",
              }}
            >
              <FaCheck /> Save
            </button>
          </div>
        </div>
      </div>
    );
  };
  const handleEndGame = () => {
    // First, clear the local storage item.
    localStorage.removeItem("bingoGame");

    // Then, reset the state to a clean initial state.
    setGameState((prev) => ({
      view: "home",

      calledNumbers: [],
      lastCalledNumber: null,
      playerBoards: [],
      isGameStarted: false,
      uncalledNumbersDeck: [],
      gameOver: false,
      gameWon: false,
    }));
    if (gameWon) {
      setMessage(`BINGO! You won 5 robux`);
      updateDocument(
        "demoReaders",
        readerProfile.id,
        {
          robux: (readerProfile.robux || 0) - 5,
        },
        auth.currentUser
      ).then((res) => {
        if (!res.success) {
          toast.error(res.message);
          return;
        }
      });
    } else {
      setMessage("Game over. Better luck next time!");
    }
  };

  const PlayOverlay = ({ onClick }) => (
    <div className="play-overlay">
      <button onClick={onClick} className="play-button">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="play-icon"
        >
          <path
            fillRule="evenodd"
            d="M4.5 5.653c0-1.426 1.529-2.348 2.796-1.615l11.54 6.348c1.268.697 1.268 2.631 0 3.328l-11.54 6.347A2.25 2.25 0 0 1 4.5 18.347V5.653Z"
            clipRule="evenodd"
          />
        </svg>
        <span className="play-text">Continue Game</span>
      </button>
    </div>
  );

  const CountdownOverlay = ({ step }) => {
    if (!step) return null;
    const colorMap = {
      3: "#06b6d4", // cyan
      2: "#f59e42", // orange
      1: "#fde047", // yellow
      GO: "#a78bfa", // purple
    };
    return (
      <div className="countdown-overlay">
        <span
          className={`countdown-number${step === "GO" ? " go" : ""}`}
          style={{ color: colorMap[step] }}
        >
          {step}
        </span>
      </div>
    );
  };

  const WinScreen = () => (
    <div className="win-screen">
      <div className="win-screen-content">
        <h1 className="win-title">BINGO!</h1>
        <p className="win-message">
          You have a winning board! You won 5 robux!
        </p>
        <button onClick={handleEndGame} className="win-screen-button">
          Claim Your Prize & Return
        </button>
      </div>
    </div>
  );

  const GameOverScreen = ({ onGoBack }) => (
    <div className="gameover-overlay">
      <div className="gameover-content">
        <h1 className="gameover-title">Game Over</h1>
        <p className="gameover-message">Better luck next time!</p>
        <button onClick={onGoBack} className="gameover-back-btn">
          Go Back
        </button>
      </div>
    </div>
  );
  const renderGame = () => {
    // Logic to calculate and display the dynamic interval
    const initialInterval = 10000;
    const finalInterval = 3000;
    const totalCallsForDecrease = 50;
    const currentCallCount = calledNumbers.length;

    let calculatedInterval = initialInterval;
    if (currentCallCount < totalCallsForDecrease) {
      const decreaseAmount = initialInterval - finalInterval;
      const decreasePerCall = decreaseAmount / (totalCallsForDecrease - 1);
      calculatedInterval = initialInterval - currentCallCount * decreasePerCall;
    } else {
      calculatedInterval = finalInterval;
    }

    const displayInterval = (calculatedInterval / 1000).toFixed(1);

    return (
      <div className="game-container">
        <ToastContainer />
        <div className="game-status-header">
          <div className="status-text-container">
            <h2 className="status-title">
              <span className="last-called-label">Last Called:</span>{" "}
              {lastCalledNumber
                ? `${getBingoLetter(lastCalledNumber)}-${lastCalledNumber}`
                : "None yet"}
            </h2>
          </div>

          {showSettings && (
            <SettingsOverlay
              onClose={() => setShowSettings(false)}
              musicEnabled={musicEnabled}
              setMusicEnabled={setMusicEnabled}
              musicVolume={musicVolume}
              setMusicVolume={setMusicVolume}
              bingoCallVolume={bingoCallVolume}
              setBingoCallVolume={setBingoCallVolume}
              bingoEnabled={bingoEnabled}
              setBingoEnabled={setBingoEnabled}
              rememberSettings={rememberSettings}
              setRememberSettings={setRememberSettings}
              onPauseResume={handlePauseResume}
              onQuit={handleQuitGame}
              isPaused={isPaused}
              onSave={() => {
                setShowSettings(false);
                // Optionally persist settings if rememberSettings is true
                if (rememberSettings) {
                  localStorage.setItem(
                    "bingoSettings",
                    JSON.stringify({
                      musicEnabled,
                      musicVolume,
                      bingoCallVolume,
                      bingoEnabled,
                      rememberSettings,
                    })
                  );
                }
              }}
            />
          )}
          {!isGameStarted && !gameOver && !gameWon && (
            <p className="status-message">
              The game is paused. Next call in: {displayInterval}s
            </p>
          )}

          {gameOver && !gameWon && (
            <div className="game-end-actions">
              <button onClick={handleEndGame} className="end-game-button">
                End Game & Return to Main Menu
              </button>
            </div>
          )}

          {gameOver && !gameWon && <GameOverScreen onGoBack={handleEndGame} />}
        </div>

        <div className="boards-display-container">
          {playerBoards.map((board, boardIndex) => (
            <div key={boardIndex} className="board-card">
              <h1 className="board-title">Board {boardIndex + 1}</h1>
              <div className="board-grid-container">
                <div className="bingo-grid">
                  {BINGO_LETTERS.map((letter) => (
                    <div key={letter} className="bingo-header">
                      {letter}
                    </div>
                  ))}
                  {[...Array(5)].map((_, rowIndex) =>
                    BINGO_LETTERS.map((letter, colIndex) => {
                      const { value, marked } = board[letter][rowIndex];
                      return (
                        <div
                          key={`${letter}-${rowIndex}`}
                          onClick={() =>
                            handleMarkSquare(boardIndex, rowIndex, colIndex)
                          }
                          className={`bingo-cell ${marked ? "marked" : ""} ${
                            value === "FREE" ? "free" : ""
                          }`}
                        >
                          {value}
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="called-numbers-panel">
          <h3 className="panel-title">Called Numbers</h3>
          <div className="called-numbers-list">
            {calledNumbers.length > 0 ? (
              calledNumbers.map((num, index) => (
                <span key={index} className="called-number-item">
                  {num}
                </span>
              ))
            ) : (
              <p className="no-numbers-message">No numbers called yet.</p>
            )}
          </div>
        </div>

        {showPlayButton && <PlayOverlay onClick={handlePlaySavedGame} />}
        {gameWon && <WinScreen />}
        {isGameStarted && (
          <>
            <div
              style={{
                position: "fixed",
                bottom: "6rem",
                right: "2rem",
                zIndex: 20,
              }}
            >
              <button
                className="settings-btn"
                onClick={() => setShowSettings(true)}
                aria-label="Settings"
                style={{
                  background: "#374151",
                  color: "#fff",
                  borderRadius: "50%",
                  padding: "1rem",
                  border: "none",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                  cursor: "pointer",
                  fontSize: "2rem",
                }}
              >
                <FaCog />
              </button>
            </div>
            <button
              onClick={handleCallBingo}
              className="bingo-call-button"
              disabled={gameWon || gameOver}
            >
              BINGO!
            </button>
          </>
        )}
      </div>
    );
  };

  const renderBoardSelection = () => (
    <div className="selection-view-container">
      <h1 className="selection-title">Select Your Boards</h1>
      <h4>Hit Bingo and win 5 robux</h4>

      <div className="button-group">
        {[1, 2, 3, 4].map((count) => {
          const cost = getBoardCost(count);
          return (
            <button
              key={count}
              onClick={() =>
                handleStartGame(
                  Array.from({ length: count }, () => generateBingoCard()),
                  cost
                )
              }
              className="board-selection-button"
            >
              <span>
                {count} Board{count > 1 ? "s" : ""}
              </span>
              <span className="board-cost">
                {cost === 0 ? "(Free)" : `(${cost} gold)`}
              </span>
            </button>
          );
        })}
      </div>

      {/* <h2 className="premade-title">Pre-made Boards</h2>
      <div className="premade-boards-container">
        {PREMADE_BOARDS.map((premade) => (
          <div key={premade.id} className="premade-board-card">
            <h3 className="premade-board-title">{premade.title}</h3>
            <div className="premade-grid-preview">
              {BINGO_LETTERS.map((letter) => (
                <div key={letter} className="premade-header">
                  {letter}
                </div>
              ))}
              {[...Array(5)].map((_, rowIndex) =>
                BINGO_LETTERS.map((letter, colIndex) => {
                  const { value, marked } = premade.board[letter][rowIndex];
                  return (
                    <div
                      key={`${letter}-${rowIndex}`}
                      className={`premade-cell ${marked ? "marked" : ""} ${
                        value === "FREE" ? "free" : ""
                      }`}
                    >
                      {value}
                    </div>
                  );
                })
              )}
            </div>
            <button
              onClick={() => handleStartGame([premade.board], 10)} // Pre-made board cost is fixed at 10
              className="premade-select-button"
            >
              Select this board
            </button>
          </div>
        ))}
      </div> */}
      {/* {message && <div className="message-box">{message}</div>} */}
    </div>
  );

  const renderHome = () => (
    <div className="home-view-container">
      <h1 className="home-title bingo-title">
        <span className="bingo-letter bingo-b">B</span>
        <span className="bingo-letter bingo-i">I</span>
        <span className="bingo-letter bingo-n">N</span>
        <span className="bingo-letter bingo-g">G</span>
        <span className="bingo-letter bingo-o">O</span>
      </h1>

      <div className="button-group">
        <button
          onClick={() =>
            setGameState((prev) => ({ ...prev, view: "boardSelection" }))
          }
          className="home-button home-button-new"
        >
          New Game
        </button>
        <button disabled className="home-button home-button-disabled">
          Multiplayer (Coming Soon)
        </button>
      </div>
      {/* {message && <div className="message-box">{message}</div>} */}
    </div>
  );

  return (
    <div className="app-container">
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <CountdownOverlay step={countdownStep} />
      <div className="main-container">
        {view === "game"
          ? renderGame()
          : view === "boardSelection"
          ? renderBoardSelection()
          : renderHome()}
      </div>
      {isPunished && <div className="punish-overlay"></div>}
    </div>
  );
};
